"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/TooltipX.css");
var TooltipX = /** @class */ (function (_super) {
    __extends(TooltipX, _super);
    function TooltipX(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState(function (prevState) { return { isOpen: !prevState.isOpen }; });
        };
        _this.state = { isOpen: false };
        return _this;
    }
    TooltipX.prototype.render = function () {
        return React.createElement(reactstrap_1.Tooltip, { className: "TooltipX", placement: this.props.placement, target: this.props.target, isOpen: this.state.isOpen, toggle: this.toggle }, this.props.children);
    };
    return TooltipX;
}(React.Component));
exports.TooltipX = TooltipX;
//# sourceMappingURL=TooltipX.js.map